import(/* webpackMode: "eager" */ "/app/app/create/page.tsx");
